export enum AuthStrategies {
  GOOGLE = "GOOGLE",
  LOCAL = "LOCAL",
  FACEBOOK = "FACEBOOK",
}
